



























































import { Component, Vue } from 'vue-property-decorator';
   @Component({ 
    })
export default class AddSupplierQuotaModal extends Vue   {
  dialog:boolean= true;

  passport:Date=null;
  birthday:Date=null;

    created(){

        

    }
  

    data () {
      return {
        range: [0, 70],

        supplierItems:['CHARTERSCANNERS','EMİN SARI'],
        suppliers: [],

        currencyItems:['EUR','RUB','TRY','UAH','USD'],
        currencies: [],

    }      

    
}
 

    closeDialog(){
      this.$emit('closed');
     
    }
};
